module.exports = __webpack_public_path__ + "img/grey.fef53fe.svg";